/*

构建vuex的根文件，mutations、actions、modules通过该文件组装导出
所有 state 在 mutations.js 中都有相应的操作

 */

import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import getters from './getters';
import actions from './actions';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    header:true,      //头部
    subBar: true,       //顶部搜索区
    sFooter: false,     //页脚
    sBg:false,
    loginWin: false,    //登陆框
    registerWin: false, //注册框
    hasLogin: false,    //是否已登录
    msgModal: {
      showMsgModal: false,
      setModal:{
        width:'',
        height:'',
        autoClose: true,
        info:''
      }
    },    // 消息提示框
    userAgreeState: false,//用户协议框
    user: null,      //用户信息
    keyword: '',     //用户搜索结果
    redirect: '',  //登陆后重定向地址
    isLoading: false,   //加载中
    isLoadingBg:false,
    conFooter:false,
    aboutTruthso:false,
    isIndex: false,
    isFeedback: false,
    isResults: false,
    isPersonal: false,
    sideNavOpen: true,
    isLoadingPersonal: false
  },
  mutations,
  getters,
  actions
});



// WEBPACK FOOTER //
// ./src/store/index.js